
import React from 'react';
import { useParams } from 'react-router-dom';
import { publish } from '../utils/socket';

/*
   parse the Params as openID
*/
const useLogin = ()=>{
       
     const {ref:openID} = useParams();
     console.log(openID);
     
     React.useEffect(()=>{
    
        try {

            if(!openID) return;
            //no ticketID is required
            console.log('runned');
            publish({
                type   :'TICKET_LOGIN',
                payload:{openID}
            });

        } catch (error){}
      
    },[openID]);

};

export default useLogin;